export default {"src":"/_next/static/media/legalWork_24.b9bb37e9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};